import { render, staticRenderFns } from "./storehouse-filters.vue?vue&type=template&id=5b98b02d"
import script from "./storehouse-filters.vue?vue&type=script&lang=js"
export * from "./storehouse-filters.vue?vue&type=script&lang=js"
import style0 from "./storehouse-filters.vue?vue&type=style&index=0&id=5b98b02d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports